import axios from 'axios';
import { cachetime } from '../config';

export default function() {
  return {
    namespaced: true,
    state: {
      home: { 
        // {locale : { data, __updatedAt }}
      },
      footer: {
        // {locale : { data, __updatedAt }}
      },
    },
    mutations: {
      SET_HOME(state, { data, locale }) {
        state.home = {
          ...state.home,
          [locale]: {
            data,
            __updatedAt: Date.now(),
          }
        }
      },
      SET_FOOTER(state, { data, locale }) {
        state.footer = {
          ...state.footer,
          [locale]: {
            data,
            __updatedAt: Date.now(),
          }
        }
      },
    },
    actions: {
      FETCH_HOME({ state, commit }, { locale }) {
        if (state.home[locale] && Date.now() - state.home[locale].__updatedAt < cachetime) return;

        return axios.get(encodeURI(`/api/banner/home`))
          .then((res) => {
            const data = res.data || [];
            commit('SET_HOME', { data, locale});
          }).catch(err => console.log(err));      
      },
      FETCH_FOOTER({ state, commit }, { locale }) {
        if (state.footer[locale] && Date.now() - state.footer[locale].__updatedAt < cachetime) return;

        return axios.get(encodeURI(`/api/banner/footer`))
          .then((res) => {
            const data = res.data || [];
            commit('SET_FOOTER', { data, locale});
          }).catch(err => console.log(err));      
      },
    },
    getters: { 
      getHome: (state) => (locale) => {
        return state.home[locale] ? state.home[locale].data || [] : [];
      },
      getFooter: (state) => (locale) => {
        return state.footer[locale] ? state.footer[locale].data || [] : [];
      }
    }
  }
}